import * as React from 'react';
import b_ from 'b_';
import { Money } from '../../../types/common';
import MoneyView from '../../MoneyView';

import './index.scss';

const b = b_.with('amount-input-stage');

export interface Props {
  amount: Money;
  onClick: (value: number) => void;
}

export const Stage: React.FC<Props> = ({ amount, onClick }) => (
  <div className={b({ disabled: !amount.value })}>
    <span className={b('value')} onClick={() => amount.value > 0 && onClick(amount.value)}>
      <MoneyView precision={0}>{amount}</MoneyView>
    </span>
  </div>
);
